 <ng-container>
  <header class="row gx-0 position-fixed w-100" role="banner">
    <div class="headwrapper col custom-flex">
      <div class="image-postion">
        <button type="button" class="btn btn-link p-0 border-0 bg-transparent" 
                (click)="homePage()" 
                aria-label="Paylife Logo - Zur Startseite">
          <img alt="Paylife Bank Logo" class="logo" />
        </button>
      </div>
      <!-- @if (!main()) { -->
      <nav class="nav-item logout-modal" aria-label="Benutzermenü">
        <div ngbDropdown class="dropdown">
          <button type="button" 
                  class="nav-link bg-transparent border-0 btn" 
                  ngbDropdownToggle 
                  (click)="collapse()"
                  [attr.aria-expanded]="toggle"
                  aria-haspopup="true"
                  [attr.aria-label]="'Benutzermenü für ' + firstName + ' ' + lastName">
            <span class="user-label">
              Angemeldet als </span><br />
            <span class="logout-option d-block">{{ firstName }} {{ lastName }}
              <span [ngClass]="
                  toggle ? 'logout-collapsible-up' : 'logout-collapsible-down'
                " class="logout-collapsible"
                role="img"
                [attr.aria-label]="toggle ? 'Menü schließen' : 'Menü öffnen'"></span></span>
          </button>
          <!-- <div ngbDropdownMenu class="border-0 bg-transparent" role="menu">
            <button ngbDropdownItem 
                    class="btn custombtn mb-2" 
                  
                    role="menuitem">
              Ausloggen
            </button>
          </div> -->
            <div ngbDropdownMenu class="border-0 bg-transparent">
          <button
            ngbDropdownItem
            class="btn custombtn mb-2"
            (click)="showPopup()"
            (keypress.enter)="showPopup()"
            tabindex="0"
            aria-label="Ausloggen"
          >
           Ausloggen
          </button>
        </div>
        </div>
      </nav>
      <!-- } -->
    </div>
  </header>
</ng-container> 
<!-- <header class="row gx-0 py-3 content">
  <div class="col d-flex">
    <div class="image-postion">
      <a>
        <img
          alt="Bawag Logo"
          class="logo"
          (click)="collapse()"
          aria-hidden="true" />
      </a>
    </div>
    <div *ngIf="firstName" class="logout-modal ms-auto">
      <span class="d-block user-label">Angemeldet als</span>
      <span class="logoutoption fw-medium">{{ firstName }}</span>
    </div>
  </div>
</header> -->



  <!-- (click)="showPopup()" -->